import React from 'react';

const TrainingSection = () => {
  return (
    <section className="training-section-two">
      <div className="bg-layer"></div>
      <div className="outer-box pull-up">
        <div className="auto-container">
          <div className="row">
            <div className="col-lg-7">
              <div className="sec-title">
                <span className="sub-title">Training &amp; Certification</span>
                <h2>Get the Immigration <br />Trainings you Deserve.</h2>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="video-box">
                <div className="inner">
                  <a
                    className="play-now-two lightbox-image"
                    href="https://www.youtube.com/watch?v=Fvae8nxzVz4"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon fa fa-play"></i>
                  </a>
                  <img alt="" className="arrow" src="/assets/images/icons/icon-arrow.png" />
                  <h4 className="title style-font">Videoyu Oynat</h4>
                  <span className="sub-title">Eğitim Videolarını İzle</span>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Training Block 1 */}
            <div className="training-block-two col-lg-4 col-md-6 col-sm-12">
              <div className="inner-box">
                <div className="image-box">
                  <figure className="image">
                    <a href="page-course-details.html">
                      <img src="/assets/images/resource/course-5.jpg" alt="Vatandaşlık Sınavı" />
                    </a>
                  </figure>
                  <div className="info-box">
                    <h5 className="title">
                      <a href="page-course-details.html">Vatandaşlık Sınavı</a>
                    </h5>
                    <div className="text">
                      There are many variations of passages of available, but the majority have suffered freedom alteration.
                    </div>
                    <a className="read-more" href="page-course-details.html">
                      <i className="fa fa-long-arrow-alt-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Training Block 2 */}
            <div className="training-block-two col-lg-4 col-md-6 col-sm-12">
              <div className="inner-box">
                <div className="image-box">
                  <figure className="image">
                    <a href="page-course-details.html">
                      <img src="/assets/images/resource/course-6.jpg" alt="IELTS Eğitimi" />
                    </a>
                  </figure>
                  <div className="info-box">
                    <h5 className="title">
                      <a href="page-course-details.html">IELTS'e Girin</a>
                    </h5>
                    <div className="text">
                      There are many variations of passages of available, but the majority have suffered freedom alteration.
                    </div>
                    <a className="read-more" href="page-course-details.html">
                      <i className="fa fa-long-arrow-alt-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Training Block 3 */}
            <div className="training-block-two col-lg-4 col-md-6 col-sm-12">
              <div className="inner-box">
                <div className="image-box">
                  <figure className="image">
                    <a href="page-course-details.html">
                      <img src="/assets/images/resource/course-7.jpg" alt="PTE Eğitimi" />
                    </a>
                  </figure>
                  <div className="info-box">
                    <h5 className="title">
                      <a href="page-course-details.html">PTE Eğitimi</a>
                    </h5>
                    <div className="text">
                      There are many variations of passages of available, but the majority have suffered freedom alteration.
                    </div>
                    <a className="read-more" href="page-course-details.html">
                      <i className="fa fa-long-arrow-alt-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TrainingSection;